import { PersonCredentialScenario } from './personCredentialScenario';

export class PersonCredentialApplication {
  public id: string;
  public credentialApplicationDefinitionId: string;
  public personId: string;
  public personName: string;
  public credentialApplicationStartDate: Date;
  public credentialApplicationEndDate: Date;
  public credentialExpirationDate: Date;
  public status: PersonCredentialApplicationStatus;
  public personCredentialId: string;
  public credentialName: string;
  public name: string;
  public applicationNumber: string;
  public credentialDefinitionId: string;
  public personCredentialScenarios: PersonCredentialScenario[] = [];

  constructor(
    id: string,
    credentialApplicationDefinitionId: string,
    personId: string,
    personName: string,
    credentialApplicationStartDate: Date,
    credentialApplicationEndDate: Date,
    credentialExpirationDate: Date,
    status: PersonCredentialApplicationStatus,
    personCredentialId: string,
    credentialName: string,
    name: string,
    scenarioNumber: string,
    credentialDefinitionId: string,
    personCredentialScenarios: PersonCredentialScenario[]
  ) {
    this.id = id;
    this.credentialApplicationDefinitionId = credentialApplicationDefinitionId;
    this.personId = personId;
    this.personName = personName;
    this.credentialApplicationStartDate = credentialApplicationStartDate;
    this.credentialApplicationEndDate = credentialApplicationEndDate;
    this.credentialExpirationDate = credentialExpirationDate;
    this.status = status;
    this.personCredentialId = personCredentialId;
    this.credentialName = credentialName;
    this.name = name;
    this.applicationNumber = scenarioNumber;
    this.credentialDefinitionId = credentialDefinitionId;
    this.personCredentialScenarios = personCredentialScenarios
      ? personCredentialScenarios.map((x) => PersonCredentialScenario.parse(x))
      : [];
  }

  static parse(obj: any): PersonCredentialApplication {
    if (obj == null) return null;
    return new PersonCredentialApplication(
      obj.id,
      obj.credentialApplicationDefinitionId,
      obj.personId,
      obj.personName,
      obj.credentialApplicationStartDate,
      obj.credentialApplicationEndDate,
      obj.credentialExpirationDate,
      obj.status,
      obj.personCredentialId,
      obj.credentialName,
      obj.name,
      obj.applicationNumber,
      obj.credentialDefinitionId,
      obj.personCredentialScenarios
    );
  }

  public getStatusClass(): string {
    switch (this.status) {
      case PersonCredentialApplicationStatus.InProgress:
        return 'active';
      case PersonCredentialApplicationStatus.Completed:
        return 'accepted';
      case PersonCredentialApplicationStatus.Archived:
        return 'archived';
    }
  }

  public getStatusText(): string {
    switch (this.status) {
      case PersonCredentialApplicationStatus.InProgress:
        return 'In Progress';
      case PersonCredentialApplicationStatus.Completed:
        return 'Completed';
      case PersonCredentialApplicationStatus.Archived:
        return 'Archived';
    }
  }
}

export enum PersonCredentialApplicationStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Archived = 'Archived',
}
